import { gql } from "@apollo/client";

export const createTargetMutation_New = gql`
  mutation createTargetMutation_New($input: createTargetMutationInput!) {
    createTargetMutation_New(input: $input) {
      id
      comment
      title
      type
      description
      reviewStatus
      performanceRating
      createdByUserId
      isAutoSavedBeforeSubmit
      targetTag
      checkin {
        items {
          id
          name
          checkInStatus
        }
      }
      logo {
        bucket
        key
        region
        url
        uploadUrl
        fileName
        isNew
      }
      unsplashImage {
        bucket
        key
        region
        url
        uploadUrl
        fileName
        isNew
      }
      targetStatus
      document {
        bucket
        key
        region
        url
        uploadUrl
        fileName
        isNew
      }
      dueDate
      weightage
      isTemplate
      skills {
        name
        definitions {
          definition
          frequency
        }
      }
      targetAttachmentLinks
      skillsAndStrengths {
        name
        isStrength
        color
        category
      }
      targetObjective {
        items {
          id
          name
          status
          isDeleted
          objectiveSequenceNo
          objectiveUser {
            items {
              id
              targetobjectiveid
              userid
              user {
                id
                firstName
                lastName
              }
            }
          }
        }
      }
      targetUser {
        items {
          id
          targetid
          userid
          strengths {
            category
            strengths
          }
          user {
            id
            firstName
            lastName
            department
          }
        }
      }
      coachTarget {
        items {
          id
          targetid
          coachid
          coach {
            id
            firstName
            lastName
          }
        }
      }
    }
  }
`;

export const markTargetStatus = gql`
  mutation markTargetStatus(
    $targetId: ID
    $userId: ID
    $processStatus: CompletionApprovalStatus!
    $comment: String
    $approvalCurrentAction: ApprovalCurrentAction
    $completionRequestByCreator: Boolean
    $completionRequestUserRole: CompletionRequestUserRole
    $performanceRating: PerformanceRating
  ) {
    targetCompletionApproval(
      input: {
        userId: $userId
        targetId: $targetId
        comment: $comment
        processStatus: $processStatus
        approvalCurrentAction: $approvalCurrentAction
        completionRequestByCreator: $completionRequestByCreator
        completionRequestUserRole: $completionRequestUserRole
        rating: $performanceRating
      }
    ) {
      id
      enableMarkCompletionRequest
      userTargetStatus
    }
  }
`;

export const uploadedUrlCheckin = gql`
  mutation uploadedUrlCheckin($input: createTargetMutationInput!) {
    createTargetMutation_New(input: $input) {
      id
      assignCheckInsToTarget {
        targetCheckins {
          surveyMultimediaCheckin {
            fileType
            s3Link {
              fileName
              url
              uploadUrl
              key
              region
              isNew
              bucket
            }
            isVideoUrl
          }
          multimediaCheckin {
            fileType
            s3Link {
              fileName
              url
              uploadUrl
              key
              region
              isNew
              bucket
            }
            isVideoUrl
          }
        }
      }
    }
  }
`;

export const updateReadAttachment = gql`
  mutation updateReadAttachment($targetId: ID!, $userId: ID!) {
    updateReadAttachment(targetId: $targetId, userId: $userId) {
      read
      count
    }
  }
`;
